import { elkotheme } from '@jotta/ui/themes/elko'
import { startApp } from '../App'

startApp(elkotheme)
